import { Component, model, output } from '@angular/core';
import { AppConfirmDialogComponent } from '../app-confirm-dialog/app-confirm-dialog.component';

/**
 * Confirmación única de "Cerrar sesión". Se usa en TODAS las pantallas que permiten salir (menú de usuario, selección de negocio, etc.) para que el
 * texto, el ícono y los botones sean siempre los mismos. No escribir otro `app-confirm-dialog` para salir del sistema.
 * (Cerrar la sesión de OTRO dispositivo es una acción distinta y tiene su propia confirmación en el perfil.)
 */
@Component({
  selector: 'app-logout-confirm',
  imports: [AppConfirmDialogComponent],
  template: `
    <app-confirm-dialog
      [(visible)]="visible"
      title="Cerrar sesión"
      description="Tendrás que volver a ingresar."
      icon="pi pi-sign-out"
      confirmLabel="Cerrar sesión"
      cancelLabel="Cancelar"
      confirmType="danger"
      (onConfirm)="confirmed.emit()"
    ></app-confirm-dialog>
  `,
})
export class AppLogoutConfirmComponent {
  readonly visible = model(false);
  readonly confirmed = output<void>();
}
